import { Agency } from '@price-pages-agency-cards/src/domain/agency/agency.entity';
import { logger } from '@price-pages-agency-cards/src/infrastructure/logger';
import { AgencyProfileUrlGenerator } from '@shared-utils/helpers/profileUrl/profileUrlGenerator';
export class AgencyTransformer {
    static transform({ agency, isRecommended }) {
        const agencyData = {
            ...agency,
            isRecommended,
            partnershipStartDatetime: this.transformSeniorityDate(agency.partnershipStartDatetime),
            profileUrl: this.getProfileUrl(agency),
        };
        return new Agency(agencyData, isRecommended);
    }
    static transformSeniorityDate(partnershipStartDatetime) {
        const date = partnershipStartDatetime ? new Date(partnershipStartDatetime) : new Date();
        if (isNaN(date.getTime())) {
            throw new Error('Invalid date format');
        }
        return date.getFullYear().toString();
    }
    // TODO: To be removed once the profile URL is provided by the API
    static getProfileUrl(agency) {
        if (!agency.legacyBrandId) {
            logger.error('Missing required legacyBrandId for profile URL generation');
            return ''; // Fallback to empty string
        }
        return AgencyProfileUrlGenerator.createProfileLink(agency.legacyBrandId, logger.error);
    }
}
